﻿
import Vue from "vue";
import './style.scss';

var previousAjax;
var nextCallback = null;
var xhrCount = 0;

var basePath = window.app.base;
var instance = new Vue({
    data: {
        showTabs: false,

        type: 1,
        modalTitle: '',
        obveznikId: '',
        hideTabs: false,
        
        activeTab: 1,

        //public Guid Id { get; set; }
        //public int InternaSifra { get; set; }
        //public string Naziv { get; set; }
        //public string Sifra { get; set; }
        //public string BarKod { get; set; }
        //public decimal CijenaBezPdv { get; set; }
        //public int IdPdv { get; set; }
        //public decimal PdvStopa { get; set; }
        //public decimal Cijena { get; set; }

        columns: [{ name: "Naziv", title: "Naziv" }, { name: "Sifra", title: "Sifra" }, { name: "PdvStopa", title: "PDV %" }, { name: "CijenaBezPdv", title: "Cijena bez pdv" },{ name: "Cijena", title: "Cijena" }],
        rows: [],
        selectedItem: {},
        searchForm: {
            typeText: "AOP",
            typeId: 0,
            modelText: "",
            modelSelect: 0
        }
    },
    methods: {
        setSearchType: function (id, type) {
            this.searchForm.typeId = id;
            this.searchForm.typeText = type;
            this.searchForm.modelText = "";
            this.searchForm.modelSelect = 0;

            this.columns = [];
            this.rows = [];
        },

        setTab: function (i) {
            this.activeTab = i;
            this.onInput();
        },

        onInput: function () {
            var q = this.searchText;
            var c = this;

            var ajaxUrl = basePath + "Home/SearchArtikalAutoComplete";
            var data = { q: c.searchForm.modelText, includeMostUsed: true };

            var seqNumber = ++xhrCount;

            previousAjax = $.ajax({
                url: ajaxUrl,
                method: "GET",
                data: data
            }).then(function (result) {
                if (seqNumber === xhrCount) {
                    for (var i = 0; i < result.length; i++) {
                        result[i]._isSelected = false;
                    }
                    c.rows = result;
                }

            }).fail(function () {
                // on fail .......
            });
        },

        selectItem: function (re) {
            for (var i = 0; i < this.rows.length; i++) {
                this.rows[i]._isSelected = false;
            }
            this.selectedItem = re;
            re._isSelected = true;
        },

        openPrompt: function (obveznikId, type, hideTabs, modalTitle, callback) {

            this.type = type;
            this.hideTabs = hideTabs;

            $(this.$el).modal('show');
            $(this.$el).find("input[type='text']").focus();

            this.modalTitle = modalTitle;
            this.obveznikId = obveznikId;
            nextCallback = callback;

            this.onInput();

            $(this.$el).on('hidden.bs.modal', function () {
                $("body").addClass("modal-open");
            });
        },

        cancel: function () {
            $(this.$el).modal('hide');

        },

        save: function () {
            var item = this.selectedItem;

            var result = {
                type: this.activeTab,
                item: item
            };

            $(this.$el).modal('hide');

            nextCallback(result);
        }
    }
});


var component = {
    v: instance,
    name: "popup-reference-pdo"
};

export default component;